import { render, staticRenderFns } from "./TextCollapse.vue?vue&type=template&id=71525ffe&scoped=true"
import script from "./TextCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextCollapse.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextCollapse.vue?vue&type=style&index=0&id=71525ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71525ffe",
  null
  
)

export default component.exports